<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="">
        <h4 class="mb-0">Выплаты</h4>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col cols="auto">
            <staff-multi-select
              v-model="selectedStaffs"
              @change="onStaffSelect"
            />
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="salary-staff-list"
      ref="salary_staff"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      bordered
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
      :current-page="currentPage"
      :per-page="perPage"
      :foot-clone="true"
      no-footer-sorting
      tfoot-class="thead-light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(staff_name)="row">
        {{row.item.staff_name}}
        <p class="m-0 p-0 text-secondary text-small">{{row.item.job_title_name}}</p>
      </template>

      <template #cell(amount)="row">
        <b-form-input id="input-amount"
                      type="number"
                      step="0.5"
                      size="sm"
                      autocomplete="off"
                      v-model.number="row.item.amount">
        </b-form-input>
      </template>

      <template #cell(ndfl_amount)="row">
        <b-form-input id="input-ndfl-amount"
                      type="number"
                      step="0.5"
                      size="sm"
                      autocomplete="off"
                      v-model.number="row.item.ndfl_amount">
        </b-form-input>
      </template>

      <template #cell(insurance_amount)="row">
        <b-form-input id="input-insurance-amount"
                      type="number"
                      step="0.5"
                      size="sm"
                      autocomplete="off"
                      v-model.number="row.item.insurance_amount">
        </b-form-input>
      </template>

      <template #cell(pension_before_amount)="row">
        <b-form-input id="input-pension-before-amount"
                      type="number"
                      step="0.5"
                      size="sm"
                      autocomplete="off"
                      v-model.number="row.item.pension_before_amount">
        </b-form-input>
      </template>

      <template #cell(pension_after_amount)="row">
        <b-form-input id="input-pension-after-amount"
                      type="number"
                      step="0.5"
                      size="sm"
                      autocomplete="off"
                      v-model.number="row.item.pension_after_amount">
        </b-form-input>
      </template>

      <template #cell(action)="row">
        <b-btn size="sm" variant="danger" @click="onDelete(row)">
          <font-awesome-icon icon="trash"/>
        </b-btn>
      </template>

      <template #foot()="row">
        {{ price(calculateTotal(row.field)) }}
      </template>

    </b-table>

    <b-card-footer id="footer" footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Записей: <b>{{totalRows}}</b>
        </b-col>
        <b-col cols="auto">
          <b-form inline>
            <b-pagination
              id="pagination"
              class="mr-2"
              pills
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"/>

            <b-form-select
              id="per-page-select"
              class="mr-2"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
              @change="onPerPageChange"/>
          </b-form>
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import salaries from "../../network/salaries";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import StaffMultiSelect from "../Staff/StaffMultiSelect";

export default {
  name: "SalaryStaffList",
  components: { StaffMultiSelect },
  mixins: [
    salaries,
    helpers, dateFormatter
  ],
  props: {
    salary: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'staff_name',
          label: "Сотрудник",
          sortable: false,
          class: 'salary-staff-list-staff-name',
          hasTotal: false
        },
        {
          key: 'amount',
          label: "Выплата",
          sortable: false,
          class: 'salary-staff-list-amount',
          formatter: 'priceFormat',
          hasTotal: true
        },
        {
          key: 'ndfl_amount',
          label: "НДФЛ",
          sortable: false,
          class: 'salary-staff-list-ndfl-amount',
          formatter: 'priceFormat',
          hasTotal: true
        },
        {
          key: 'insurance_amount',
          label: "Страховые",
          sortable: false,
          class: 'salary-staff-list-insurance-amount',
          formatter: 'priceFormat',
          hasTotal: true
        },
        {
          key: 'pension_before_amount',
          label: "Пенс. до первыш.",
          sortable: false,
          class: 'salary-staff-list-ndfl-amount',
          formatter: 'priceFormat',
          hasTotal: true
        },
        {
          key: 'pension_after_amount',
          label: "Пенс. после первыш.",
          sortable: false,
          class: 'salary-staff-list-pension-amount',
          formatter: 'priceFormat',
          hasTotal: true
        },
        {
          key: 'action',
          label: "Действия",
          class: 'salary-staff-list-action'
        },
      ],
      isBusy: false,
      sortBy: 'id',
      sortDesc: true,
      pageOptions: [10, 50, 100, 300, 500],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      deleteRow: {
        id: null,
        name: ''
      },
      selectedStaffs: []
    }
  },
  watch: {
    salary: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal == null) {
          this.items = [];
          this.totalRows = 0;
          return
        }

        if (newVal.salary_staffs == null) {
          this.items = [];
          this.totalRows = 0;
          return
        }

        this.items = newVal.salary_staffs;
        this.totalRows = this.items.length;
      }
    },
    items: {
      deep: true,
      handler() {
        this.$emit('change', this.items);
      }
    }
  },
  methods: {
    calculateTotal(field) {
      if (!field.hasTotal) { return null; }

      return this.items
        .map(obj => obj[field.key])
        .reduce((acc, current) => acc + current, 0);
    },
    price(value) {
      if (value == null) { return value; }
      if (!this.isCustomNumber(value)) { return value; }
      return this.priceFormat(value, false);
    },
    // Pagination
    onPerPageChange() {
      this.currentPage = 1;
    },
    onRowClicked(item) {
      this.onEdit(item);
    },
    getShortName(surname, name, patronymic) {
      const firstCharName = name.slice(0,1);
      const firstCharPatronymic = patronymic.slice(0,1);
      if (firstCharPatronymic === '') {
        return `${surname} ${firstCharName}.`;
      }
      return `${surname} ${firstCharName}. ${firstCharPatronymic}.`;
    },
    onDelete(row) {
      if (row.item) {
        this.deleteRow.id = row.item.staff_id;
      }
      const title = "Удаление выплаты"
      const message = `Вы уверены что хотите удалить запись ${this.deleteRow.name}?`;
      this.showModalDelete(title, message, function () {
        this.removeItem(this.deleteRow);
      }.bind(this));
    },
    removeItem(row) {
      this.items = this.items.filter(function (item) { return item.staff_id !== row.id });
    },
    formattedToServerDate(date) {
      if (!this.isDateValid(date)) { return null; }

      if (date != null) {
        date = this.localISOString(this.getDateToServer(date));
      }

      return date;
    },
    isDateValid(dateStr) {
      return !isNaN(new Date(dateStr));
    },
    onStaffSelect(staffs) {
      if (staffs.length > 0) {
        staffs.forEach(async function (staff) {
          if (!this.existStaff(staff.id)) {
            const salary = await this.makeSalaryStaff(staff);
            if (salary != null) {
              this.items.push(salary);
            }
          }
        }.bind(this));
      }
    },
    existStaff(id) {
      return this.items.find(x => x.staff_id === id) !== undefined;
    },
    async makeSalaryStaff(staff) {
      const data = {
        period: this.formattedToServerDate(this.salary.period),
        staff_id: staff.id,
        salary_type_id: this.salary.salary_type_id
      }
      const result = await this.getNewSalaryStaff(data);
      const salary = result.data;

      return salary;
    }
  }
}
</script>

<style>
#salary-staff-list td {
  vertical-align: middle;
}

#salary-staff-list th {
  vertical-align: middle;
}

.salary-staff-list-name {
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 200px;
  max-width: 200px;
  width: 200px;
}

.salary-staff-list-amount {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
}

.salary-staff-list-ndfl-amount {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
}

.salary-staff-list-insurance-amount {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-staff-list-pension-amount {
  min-width: 120px;
  max-width: 120px;
  width: 120px;
}

.salary-staff-list-action {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Salary/SalaryStaffList.vue